import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import {
  fullNamePresenter,
  getPatientStatus,
  capitalize,
  getPatientCcmStatus,
  getPatientPcmStatus,
} from 'utils';
import withLoader from 'components/organisms/withLoader';
import common from 'constants/common';
import InternalAdmissionDownloadButton from 'components/templates/admin/internalAdmissonForm/DownloadButton';
import { intervalToDuration } from 'date-fns';
import { parseDateSafe } from '../../../../../utils/timeHelper';

export const getPatientCovidStatus = (status) =>
  common.covidStatuses.positive.status === status
    ? common.covidStatuses.positive.label
    : '';

const ShortInfo = ({ patient, patientLoading }) => {
  const { profile } = patient;
  const { label: ccmStatus } = getPatientCcmStatus(profile?.ccmStatus);
  const status = getPatientStatus(profile?.status);
  const pcmStatus = getPatientPcmStatus(profile?.pcmStatus);
  const covidStatus = getPatientCovidStatus(profile?.covidStatus);
  const today = new Date();
  const endDate = parseDateSafe(profile?.holdingStatus?.endTime);

  const remainingDays =
    endDate &&
    intervalToDuration({
      start: today,
      end: endDate,
    })?.days;
  return (
    <Card className="patient-info card-border card--margin-bottom">
      <CardBody className="card--padding">
        {withLoader(
          patientLoading,
          profile && (
            <>
              <div
                className="patient-info__status-indicator"
                style={{
                  backgroundColor: status.color,
                }}
              />
              <div className="patient-info__main-row">
                <span className="patient-info__name">
                  {fullNamePresenter(profile)}
                </span>
                {covidStatus && (
                  <>
                    <span className="patient-info__divider" />
                    <span className="patient-info__covid-status">
                      {covidStatus}
                    </span>
                  </>
                )}
                {profile.doNotCall && (
                  <>
                    <span className="patient-info__divider" />
                    <span className="patient-info__covid-status">
                      Do not call
                    </span>
                  </>
                )}
                {profile.holdingStatus &&
                  profile.holdingStatus?.status !== 'active' && (
                    <>
                      <span className="patient-info__divider" />
                      <div className="patient-info__holding-status">
                        <span>
                          {capitalize(profile.holdingStatus?.status)}: (
                          {remainingDays + 1} days)
                        </span>
                      </div>
                    </>
                  )}
              </div>
              <div className="patient-info__bottom-row">
                <div>DOB: {profile.birthDate?.replaceAll('-', '/')}</div>
                <span className="divider" />
                <div>Patient ID: {profile.guid}</div>
                <span className="divider" />
                <div>RPM Status: {status.label}</div>
                <span className="divider" />
                <div>CCM Status: {ccmStatus}</div>
                <span className="divider" />
                <div>PCM Status: {pcmStatus}</div>
              </div>
              <div className="patient-info__actions">
                <InternalAdmissionDownloadButton patient={patient} />
              </div>
            </>
          ),
        )}
      </CardBody>
    </Card>
  );
};

ShortInfo.propTypes = {
  patient: PropTypes.shape({
    profile: PropTypes.shape({
      guid: PropTypes.string,
      title: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      covidStatus: PropTypes.string,
      status: PropTypes.string,
      doNotCall: PropTypes.bool,
      ccmStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      pcmStatus: PropTypes.bool,
      birthDate: PropTypes.string,
      holdingStatus: PropTypes.shape({
        status: PropTypes.string,
        endTime: PropTypes.string,
      }),
      disabledCreateInternalAdmissionForms: PropTypes.bool,
    }),
  }),
  patientLoading: PropTypes.bool,
};

export default ShortInfo;
